import React, { useEffect, useState } from "react";
import skillbrigdge from "../../Assets/skillbrigdge.png";
import { CalenderIcon, CardIcon, SortIcon } from "../../Assets/Icons";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import moment from "moment";
import { ALLOCATION_EXTEND, ALLOCATION_STATUS_CHANGE, GET_SUBSCRIPTION_DETAILS } from '../../apiClient/apiEndpoints.js';
import CustomDateRangePicker from "../DateRangePicker.js";
import Skeleton from "react-loading-skeleton";
const subscriptions = [
  {
    name: "Skill Bridge XR",
    category: "Training",
    price: "₹ 29,99,99.00",
    duration: "per year",
    status: "Renew",
    date: "21 February",
    applicationicon: skillbrigdge,
  },
  {
    name: "Skill Bridge XR",
    category: "Training",
    price: "₹ 29,99,99.00",
    duration: "per year",
    status: "Expired",
    date: "21 February",
    applicationicon: skillbrigdge,
  },
];

const modules = [
  {
    title: "Tank Truck Decantation at Retail Outlet",
    category: "Training",
    renewDate: "21 February",
    price: "₹ 29,99,99.00",
    thumbnail:
      "https://cdn.simulanis.io/sso/uno/production/resources/8515a218-816d-4097-a327-3ea026b8a233/thumbnail/Confined-Space-Safety.jpg",
    expired: true,
  },
  {
    title: "Tank Truck Decantation at Retail Outlet",
    category: "Training",
    renewDate: "21 February",
    thumbnail:
      "https://cdn.simulanis.io/sso/uno/production/resources/8515a218-816d-4097-a327-3ea026b8a233/thumbnail/Confined-Space-Safety.jpg",
    expired: false,
  },
  {
    title: "Tank Truck Decantation at Retail Outlet",
    category: "Training",
    renewDate: "21 February",
    price: "₹ 29,99,99.00",
    thumbnail:
      "https://cdn.simulanis.io/sso/uno/production/resources/8515a218-816d-4097-a327-3ea026b8a233/thumbnail/Confined-Space-Safety.jpg",
    expired: false,
  },
];

const ApplicationModulePlanList = ({ subscriptionId }) => {

  const [applicationItemIndex, setApplicationItemIndex] = useState(null);
  const [applicationDates, setApplicationDates] = useState([null, null])
  const [resourceItemIndex, setResourceItemIndex] = useState(null);
  const [resourceDates, setResourceDates] = useState([null, null])

  const [details, setDetails] = useState({
    data: {},
    allocation: {
      application: [],
      resource: [],
    },
  });

  const getSubscriptionDetails = async () => {
    try {
      let data = await apiClient.get(`${SSO_URL}${GET_SUBSCRIPTION_DETAILS}/${subscriptionId}`);
      setDetails(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSubscriptionDetails();
  }, [subscriptionId]);

  const handleStatusChangeClick = async (value, id) => {
    try {

      const bodyData = {
        status: !value
      }

      await apiClient.post(`${SSO_URL}${ALLOCATION_STATUS_CHANGE}/${id}`, bodyData);
      getSubscriptionDetails();
    } catch (error) {
      console.log(error);
    }
  }

  const handleRenewSubscription = async (allocationId, type) => {
    try {
      let dates = {
        "APPLICATION": {
          start: applicationDates[0],
          end: applicationDates[1],
        },
        "RESOURCE": {
          start: resourceDates[0],
          end: resourceDates[1],
        }
      }

      if(!dates[type].start || !dates[type].end ){
         return
      }

      const bodyData = {
        start: dates[type].start,
        end: dates[type].end
      }

      await apiClient.post(`${SSO_URL}${ALLOCATION_EXTEND}/${allocationId}`, bodyData);
      getSubscriptionDetails();
      setApplicationItemIndex(null);
      setApplicationDates([null, null]);
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateDateRange = (range, type) => {
    if (type === "APPLICATION") {
      if (range === null) {
        setApplicationDates([null, null]);
      } else {
        setApplicationDates(range);
      }
    }

    if (type === "RESOURCE") {
      if (range === null) {
        setResourceDates([null, null]);
      } else {
        setResourceDates(range);
      }
    }
  };

  return (
    <>
      <div className="org-application">
        <div className="application-heading">
          <h5>Application</h5>
        </div>

        {details?.allocation?.application.map((application, index) => (
          <div className={`application-card-list ${application.expired ? "inactive" : "active"}`} key={index}>
            <div className="subscription-item">
              <div className="application-thumb">
                <img src={application.icon} alt={application.name} referrerPolicy="no-referrer" />
              </div>
              <div className="name-info">
                <h4>{application.name}</h4>
                <h6>{application.expired ? "Expired" : "Renew"}</h6>
              </div>
            </div>

            <div className="application-price">
              <div className="price-detail">
                <p className="mb-0">
                  <span>
                    <CalenderIcon />
                  </span>
                  <span className="renew"> Start Date: </span>
                  <span>{moment(application.validity.validFrom).format("LL")}</span>
                </p>
                <p className="mb-0">
                  <span>
                    <CalenderIcon />
                  </span>
                  <span className="renew"> {application.expired ? "Expired: " : "End Date: "} </span>
                  <span>{moment(application.validity.validTill).format("LL")}</span>
                </p>
              </div>
              <div className="plan-renew">
                {/* <button className="pausebutton" onClick={()=>handleStatusChangeClick(application.status, application.allocationId)} >
                  {application.status ? "Pause" : "Active"}
                </button> */}
                <button className="renewbutton" onClick={() => {setApplicationItemIndex(index); setApplicationDates([application.validity.validFrom, application.validity.validTill])}}>
                  {application.expired ? "Extend Subscription" : "Renew Subscription"}
                </button>
              </div>
            </div>

            {applicationItemIndex === index &&
              <div className="application-price">
                <div className="price-detail"> </div>
                <div className="plan-renew">
                  <CustomDateRangePicker
                    dateRange={[applicationDates[0] ? new Date(applicationDates[0]) : null, applicationDates[1] ? new Date(applicationDates[1]) : null]}
                    setDateRange={(dates) => handleUpdateDateRange(dates, "APPLICATION")}
                  />
                  <button className="pausebutton" onClick={() => handleRenewSubscription(application.allocationId, "APPLICATION")} >
                    Save
                  </button>
                  <button className="pausebutton" onClick={() => { setApplicationItemIndex(null); setApplicationDates([null, null]) }} >
                    Cancel
                  </button>
                </div>
              </div>
            }

          </div>
        ))}

        <div className="application-heading pt-4">
          <h5>Module</h5>
          {/* <p className="sort"> Sort <SortIcon /> </p> */}
        </div>

        {details?.allocation?.resource.map((module, index) => (

          <div className={`module-list ${module.expired ? "inactive" : "active"}`} key={index}>

            <div className="module-data">
              <div className="module-thumb">
                <img src={module.resource.thumbnail} alt={module.resource.name} />
              </div>

              <div className="module-content">
                <h4>{module.resource.name}</h4>

                <p className="renewdate">
                  <span > <CalenderIcon />  </span>
                  <span > Start Date: </span>
                  <span>{moment(module.validity.validFrom).format("LL")}</span>
                </p>

                <p className="renewdate">
                  <span> <CalenderIcon /></span>
                  <span> {module.expired ? "Expired: " : "End Date: "}</span>{" "}
                  <span>{moment(module.validity.validTill).format("LL")}</span>{" "}
                </p>

                <div className="modulerenew">
                  {resourceItemIndex === index &&
                      <div className="plan-renew ">
                        <CustomDateRangePicker
                          dateRange={[resourceDates[0] ? new Date(resourceDates[0]) : null, resourceDates[1] ? new Date(resourceDates[1]) : null]}
                          setDateRange={(dates) => handleUpdateDateRange(dates, "RESOURCE")}
                        />
                        <button className="pausebutton" onClick={() => handleRenewSubscription(module.allocationId, "RESOURCE")} >
                          Save
                        </button>
                        {" "}
                        <button className="pausebutton" onClick={() => { setResourceItemIndex(null); setResourceDates([null, null]) }} >
                          Cancel
                        </button>
                      </div>
                  }
                </div>
              </div>


            </div>

            <div className="renew-button">
              <button className="renewbutton" onClick={() => { setResourceItemIndex(index); setResourceDates([module.validity.validFrom, module.validity.validTill]) }}>
                {module.expired ? "Extend Subscription" : "Renew Subscription"}
              </button>
            </div>

          </div>
        ))}

        {/* <div className="module-list" >
            <div className="module-data">
              <div className="module-thumb">
              <Skeleton  width="100%" height="100%" highlightColor="#fff" />
              </div>
              <div className="module-content">
                <h4>
                <Skeleton  width="15rem" height="1.5rem" /> 
                </h4>
                
                <p className="renewdate">
                 
                  <CalenderIcon />  
                  <span className="ms-2">
                  <Skeleton  width="10rem" height="1rem" />
                    </span>
                </p>
                <p className="renewdate">
                  
                  <CalenderIcon /> 
                  <span className="ms-2">
                  <Skeleton  width="10rem" height="1rem" />
                  </span>
                </p>
              </div>
            </div>
            <div className="renew-button">
            </div>
          </div> */}


      </div>
    </>
  );
};

export default ApplicationModulePlanList;
